import { render, staticRenderFns } from "./OrganizationsRating.vue?vue&type=template&id=25567b03&scoped=true&"
import script from "./OrganizationsRating.vue?vue&type=script&lang=js&"
export * from "./OrganizationsRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25567b03",
  null
  
)

export default component.exports